import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { initialState, AnnexState } from './annex.state';
import * as annexActions from './annex.actions';

const reducer: ActionReducer<AnnexState, Action> = createReducer(
  initialState,

  on(
    annexActions.getAnnexes,
    (state, { opts }): AnnexState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    annexActions.getAnnexesSuccess,
    (state, { annexes, userProcessId }): AnnexState => ({
      ...state,
      annexesInUserProcess: { userProcessId, annexes },
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    annexActions.getAnnexesError,
    (state, { errorMessage }): AnnexState => ({
      ...state,
      loading: false,
      errorMessage,
    })
  ),

  on(
    annexActions.createAnnex,
    (state, { opts }): AnnexState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    annexActions.createAnnexSuccess,
    (state, { annex, userProcessId }): AnnexState => ({
      ...state,
      annexesInUserProcess: {
        annexes: [...state.annexesInUserProcess.annexes, annex],
        userProcessId,
      },
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    annexActions.createAnnexError,
    (state, { errorMessage }): AnnexState => ({
      ...state,
      loading: false,
      errorMessage,
    })
  ),

  on(
    annexActions.updateAnnex,
    (state, { opts }): AnnexState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    annexActions.updateAnnexSuccess,
    (state, { annex }): AnnexState => ({
      ...state,
      annexesInUserProcess: {
        annexes: state.annexesInUserProcess.annexes.map(a1 => (a1.id === annex.id ? annex : a1)),
        userProcessId: state.annexesInUserProcess.userProcessId,
      },
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    annexActions.updateAnnexError,
    (state, { errorMessage }): AnnexState => ({
      ...state,
      loading: false,
      errorMessage,
    })
  ),

  on(
    annexActions.removeAnnex,
    (state, { opts }): AnnexState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    annexActions.removeAnnexSuccess,
    (state, { annexId }): AnnexState => ({
      ...state,
      annexesInUserProcess: {
        annexes: state.annexesInUserProcess.annexes.filter(a1 => a1.id !== annexId),
        userProcessId: state.annexesInUserProcess.userProcessId,
      },
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    annexActions.removeAnnexError,
    (state, { errorMessage }): AnnexState => ({
      ...state,
      loading: false,
      errorMessage,
    })
  ),

  on(
    annexActions.getSpecialities,
    (state, {}): AnnexState => ({
      ...state,
      loadingSpecialities: true,
      errorMessage: null,
    })
  ),
  on(
    annexActions.getSpecialitiesSuccess,
    (state, { specialities }): AnnexState => ({
      ...state,
      loadingSpecialities: false,
      errorMessage: null,
      specialities,
    })
  ),
  on(
    annexActions.getSpecialitiesError,
    (state, { errorMessage }): AnnexState => ({
      ...state,
      loadingSpecialities: false,
      errorMessage,
    })
  )
);

export function annexReducer(state: AnnexState | undefined, action: Action): AnnexState {
  return reducer(state, action);
}
